import { site } from '../config';
import HelpBand from './HelpBand';
import PageHero from './PageHero';

export default function LegalPage({ title, intro, children }) {
  return (
    <>
      <PageHero title={title}>Last updated: {site.updated}</PageHero>
      <div className="wrap legal">
        <article className="legal-card">
          {intro && <p className="legal-intro">{intro}</p>}
          {children}
        </article>
      </div>
      <HelpBand title="Questions about this policy?" />
    </>
  );
}
